<template>
  <nav>
    <v-card
      max-width="960px"
      elevation="0"
      class="mx-auto fill-height pa-5"
      :class="!mobile() ? 'rounded-xxl' : ''"
      align="center"
    >
      <v-row
        class="fill-height"
        align="center"
      >
        <v-col
          fill-height
          align="center"
        >
          <v-img
            :src="require('../assets/' + pageImage + '.png')"
            width="100%"
            max-width="400px"
            class="mx-auto mb-10"
          />
          <p class="text-h5 font-weight-bold">
            {{ pageTitle }}
          </p>
          <!-- eslint-disable vue/no-v-html -->
          <p
            class="text-body-1"
            v-html="pageText"
          />
        </v-col>
      </v-row>
    </v-card>
  </nav>
</template>
<script>
import { repeatedMethodsMixin } from "../mixins/repeatedMethodsMixin";

export default {
  props: {
    pageTitle: {
      type: String,
      default: ''
    },
    pageText: {
      type: String,
      default: ''
    },
    pageImage: {
        type: String,
        default: 'empty_page'
    },
  },
  mixins: [repeatedMethodsMixin],
}
</script>